import React from 'react';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';
import useStyles from './styles';
import { useTheme } from '@material-ui/core';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import { withPermissions } from 'middlewares';
import { useDispatch } from 'react-redux';
import NavigationActions from 'redux/reducers/gl_navigation_reducer/actions';
import PermissionsEnum from 'constants/permissions';

const MainMenuFloating = withPermissions(() => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  const fab = {
    color: 'primary' as 'primary',
    className: classes.fab,
    icon: <MenuOpenIcon />,
    label: 'Add',
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return (
    <Zoom
      key={fab.color}
      in={true}
      timeout={transitionDuration}
      style={{
        transitionDelay: `${true ? transitionDuration.exit : 0}ms`,
      }}
      unmountOnExit
    >
      <Fab
        onClick={() =>
          dispatch(NavigationActions.setSideMenuVisiblityAction(true))
        }
        aria-label={fab.label}
        className={fab.className}
        color={fab.color}
      >
        {fab.icon}
      </Fab>
    </Zoom>
  );
}, PermissionsEnum.NavigationAdministrationMenu);

export default React.memo(MainMenuFloating);
